module.exports = __webpack_public_path__ + "img/hero-9.ea82d311.png";